module.exports = __webpack_public_path__ + "static/media/carryinghelp.635acf8c.png";